import { useContext } from 'react';

import { useGetServiceScheduleQuery } from '@/api/generated';
import { GilmoreHealthContext } from '@/data/GilmoreHealthContext';

import { useProvider } from './ProviderContext';

export const useGilmoreEvents = () => {
    const { gilmoreEventDataSet, ...rest } = useContext(GilmoreHealthContext);
    const provider = useProvider();
    const isPartner = provider?.type !== 'DIRECT';
    useGetServiceScheduleQuery(
        { input: { providerArn: provider.arn } },
        {
            enabled: Boolean(provider.arn) && isPartner,
            refetchOnWindowFocus: true,
            onSuccess: ({ getServiceSchedule: { schedules } }) => gilmoreEventDataSet(schedules),
        },
    );

    return rest;
};
